<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn>
        <div v-if="loading">Loading...</div>
        <div v-else>
            <div v-html="html"></div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            loading: true,
            html: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
        };
    },

    methods: {

        fetchLCData(lid, copy_name) {
            this.loading = true;
            axios.post("/certificate/fetchLC", { lid: lid, copy_name: copy_name })
            .then((res) => {
                if (res.data.flag === "YES") {
                    this.html = res.data.html
                } else {
                    this.showSnackbar("error",res.data.snackbar || 'Failed to fetch LC')
                }
            })
            .catch(() => {
                this.showSnackbar("error","Error in loading LC")
            })
            .finally(() => {
                this.loading = false;
            });
        },

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
            that.$store.state.drawer = true;
            };
            setTimeout(() => {
            window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        const lid = this.$route.query.lid;
        const copy_name = this.$route.query.copy_name;

        if (!lid) {
            alert("Invalid access");
            return;
        }

        this.fetchLCData(lid, copy_name);
    }
};
</script>
<style scoped>
.data-table td.index-col {
    width: 4%;
    white-space: nowrap;
    text-align: center;
}

.dotted-line {
    border-bottom: 2px dotted #000;
    width: 100%;
}

.small-table td {
    border: 1px solid black;
    padding-left: 10px;
    text-align: left;
}

.small-table {
    border: 1px solid black;
}

.small-table td:first-child {
    width: 50%;
}

.data-table td {
    border: 1px solid black;
    text-align: left;
}

.data-table {
    border: 1px solid black;
    text-align: left;
}

.printdiv {
    height: auto;
    margin-left: 10%;
    margin-right: 10%;
    padding: 10px;
    /* border: 1px solid black; */
    background-color: white;
    font-weight: 500;
}

p {
    margin: 0;
}

/* print lc css */
@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .printdiv {
        margin: 0;
        padding: 0;
    }

    @page {
        size: A4;
        margin: none;
        padding-top: 0;
        size: 11.5in 17.4in;
    }
}
</style>